import { get } from 'lodash';

import { Thesaurus } from './thesaurus-data-store';

export const identifer = (thesaurus: Thesaurus) =>
    get(thesaurus, 'thesaurusCS.identifier', null)
